import "./menus.css";

import React from "react";

import { MENUS } from "../../data/content";
import PageMeta from "../general/PageMeta";
import { LinkButton } from "../general/PageSections";

//Stand-alone page (not in the menu) with a dark box over a dimmed photo, linking to the food menu and drinks list PDFs
const Menus = () => {
  return (
    <section className={"menus"}>
      <PageMeta
        title={"Menus"}
        description={MENUS.DESCRIPTION}
      />
      <img
        src={"/images/services/poolside-breakfast.webp"}
        alt={""}
        className={"menus-image"}
      />
      <div className={"menus-box"}>
        <h1 className={"menus-title"}>{MENUS.TITLE}</h1>
        <div className={"menus-buttons"}>
          {MENUS.BUTTONS.map((button) => (
            <LinkButton
              key={button.label}
              href={button.href}
              className={"menus-button"}
            >
              {button.label}
            </LinkButton>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Menus;
